<template>
    <div class="form-list__line">
        <label class="radio-row radio-row--light js-trigger-row-container">
            <input v-if="cnt==1" type="radio" name="profile" class="radio-row__radio js-trigger-row req" checked>
            <input v-if="cnt>1" type="radio" name="profile" class="radio-row__radio js-trigger-row req" @click="SetIndex">

            <span class="radio-row__bg"></span>
            <div class="radio-row__check"></div>
            <div class="radio-row__body">
                <div class="radio-row__head radio-row__head--fix" v-bind:style="(isClosed) ? 'color: red' : 'color: black' ">{{acc.contragentShortName}}</div>
                <div class="radio-row__center line-form__double-btn-width line-form__double-btn-width--offset-left">
                    <div class="radio-row__caption radio-row__caption--light">ЛС: {{acc.accountNumber}}</div>
                </div>
                <div class=" line-form__double-btn-width line-form__double-btn-width--offset-left">
                    <div class="text-edit-container text-edit-container--min-width js-edit-payment-amount-container">
                        <span v-if="!isChecked" class="js-button-payment-amount"><span class="js-payment-amount-count-block js-trigger-row-price">{{formatNum(saldo.toString())}}</span> ₽</span>
                        <div v-else class="line-form__amount-edit js-block-edit-payment-amount">
                            <input @keydown="keydown($event)"
                                   @keyup="keyup($event)"
                                   @blur="blur($event)"
                                   @change="change($event)"
                                   @focus="focus($event)"
                                   class="text-edit-input js-edit-payment-amount-input js-trigger-row-price-input"
                                   v-model="visualSum" data-mask-max-8 type="text"
                                   v-bind:placeholder="formatNum(saldo.toString())">
                            <button v-if="isEditSum" class="text-edit-trigger text-edit-trigger--remove js-clear-payment-amount"><i @click="CancelEdit()" class="icon icon--close"></i></button>
                        </div>
                        <!--<button v-if="!isEditSum" @click="beginEdit()" class="text-edit-trigger text-edit-trigger--abs"><i class="icon icon--edit"></i></button>
                        <button v-if="isEditSum" @click="endEdit()" class="text-edit-trigger text-edit-trigger--abs text-edit-trigger--remove js-check-edit-payment-amount"><i class="icon icon--check"></i></button>-->
                    </div>
                </div>
            </div>
        </label>
    </div>
</template>
<script>
    export default {
        name: 'account',
        props: ['acc', 'index', 'cnt', 'indexAcc'],
        data: function () {
            return {
                visualSum: '',
                saveSum: '',
                saldo: 0.0,
                isEditSum: false,
                isChecked: false,
                isClosed: false
            }
        },
        methods: {
            keydown: function (event) {
                this.saveSum = event.srcElement.value;
                let key = event.key;
                switch (key) {
                    case 'ArrowLeft':
                    case 'ArrowRight':
                    case 'Delete':
                    case 'Backspace':
                        break;
                    case ',':
                        if (this.saveSum.indexOf(',') > -1) event.preventDefault();
                        break;
                    case 'Enter':
                        event.srcElement.blur();
                        break;
                    default:
                        if (/^[0-9]$/i.test(key)) {
                            var sum = this.saveSum.split(',');
                            if (sum[0].length > 8 && this.saveSum.indexOf(',') == -1) {
                                event.preventDefault(); return;
                            }
                            if (sum[0].length > 8 && sum[1].length > 1) event.preventDefault();
                        }
                        else
                            event.preventDefault();
                        break;
                }
            },
            keyup: function (event) {
                var sum = event.srcElement.value;
                var kop = '';
                var rub = '';
                rub = sum.split(',')[0];
                if (sum.indexOf(',') > -1)
                    kop = sum.split(',')[1];
                if (rub.length > 8 || kop.length > 2) {
                    this.visualSum = this.saveSum;
                    event.srcElement.value = this.saveSum;
                }
                return;
            },
            change: function (event) {
                //var sum = event.srcElement.value;
                //if (sum.split(',')[0].length == 0)
                //    sum = '0' + sum;
                //if (sum.indexOf(',') > -1 && sum.split(',')[1].length == 0)
                //    sum += '00';
                //if (sum.indexOf(',') > -1 && sum.split(',')[1].length == 1)
                //    sum += '0';
                //event.srcElement.value = sum;
                this.isEditSum = true;
                return;
            },
            focus: function (event) {
                event.srcElement.value = event.srcElement.value.replaceAll(' ', '');
            },
            blur: function (event) {

                var sum = this.visualSum;
                if (sum.split(',')[0].length == 0)
                    sum = '0' + sum;
                if (sum.indexOf(',') > -1 && sum.split(',')[1].length == 0)
                    sum += '00';
                if (sum.indexOf(',') > -1 && sum.split(',')[1].length == 1)
                    sum += '0';
                this.visualSum = sum;

                var len = event.srcElement.value.split(',')[0].length;
                if (len > 3) {
                    var sum = ''
                    for (let i = 1; i <= len; i++) {
                        sum = this.visualSum[len - i] + sum;
                        if (i % 3 == 0 && len != i)
                            sum = ' ' + sum;
                    }
                    if (this.visualSum.split(',')[1])
                        this.visualSum = sum + ',' + this.visualSum.split(',')[1];
                    else
                        this.visualSum = sum;
                }
                this.SetSumForPay();
            },
            CancelEdit: function () {
                this.visualSum = this.formatNum(this.saldo.toString());
                this.SetSumForPay();
                this.isEditSum = false;
            },
            downEdit: function (event) {
                this.saveSum = this.visualSum;
            },
            beginEdit: function () {
                this.saveSum = this.visualSum.replaceAll(' ', '');
                this.visualSum = this.saveSum;
                this.isEditSum = !this.isEditSum;
            },
            endEdit: function () {
                if (this.visualSum == '')
                    this.visualSum = this.formatNum(this.saldo.toString());
                else
                    this.visualSum = this.formatNum(this.visualSum);
                this.isEditSum = !this.isEditSum;
                this.SetSumForPay();
            },
            editSum: function () {
                if (this.visualSum !== '') {
                    var money = this.visualSum.replaceAll(',', '.');
                    if ((money.split('.')[1]) && (money.split('.')[1].length > 2) || isNaN(Number(money))) {
                        this.visualSum = this.saveSum;
                        return;
                    }
                    if (!(((this.acc.status) && (this.acc.status == '0')) || ((this.acc.legalAccountStatus) && (this.acc.legalAccountStatus == 4))))
                        if (Number(money) > this.saldo)
                            this.visualSum = this.saldo.toString().replaceAll('.', ',');
                }
            },
            SetIndex: function () {
                this.$emit('updateIndex', this.index);
                this.$emit('updateSum', this.visualSum);
                this.isChecked = true;
            },
            ClearChecked: function () {
                this.isChecked = false;
                this.visualSum = this.formatNum(this.saldo.toString())
            },
            SetSumForPay: function () {
                if (this.indexAcc == this.index)
                    this.$emit('updateSum', this.visualSum);
            },
            formatNum: function (num) {
                num = num.replace('.', ',');
                var res = '';
                if (num.indexOf(',') == 0)
                    num = '0' + num;
                var ss = num.split(',');
                if (ss.length == 2) {
                    if (ss[1].length > 2) ss[1] = ss[1].substring(0, 2);
                    if (ss[1].length > 0) res = ',' + ss[1];
                    else res = ss[1];
                }
                var index = ss[0].length;
                while (index > 0) {
                    index--;
                    res = ss[0].substr(index, 1) + res;
                    if (index == 0) break;
                    var sp = (ss[0].length - index) % 3;
                    if (sp == 0)
                        res = ' ' + res;
                }
                return res;
            }
        },
        mounted() {
            if (this.acc.isFl) {
                this.saldo = this.acc.toPay;
                this.visualSum = this.formatNum(this.saldo.toString());
            }
            else {
                var sum = 0.0;
                for (var i in this.acc.invoices)
                    if (this.acc.invoices[i].invoiceType.id > 0 && this.acc.invoices[i].deptEnd > 0.0)
                        sum += this.acc.invoices[i].deptEnd;
                this.saldo = sum;
                this.visualSum = this.formatNum(sum.toString());
            }
            if (this.cnt == 1) {
                this.$emit('updateIndex', 0);
                this.$emit('updateSum', this.visualSum);
                this.isChecked = true;
            }
            else
                this.isChecked = false;
            this.isClosed = (this.acc.status != '0' && this.acc.legalAccountStatus != 4);
            if (this.isClosed) {
                if (this.acc.terminationDate != undefined)
                    this.acc.EndDate = this.acc.terminationDate;
                this.acc.contragentShortName += (this.isClosed) ? (' Закрыт ' + this.acc.EndDate) : '';
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Scripts/app/pay/account.vue